import React, { useCallback } from 'react';
import {
    required,
    minLength,
    maxLength,
    minValue,
    maxValue,
    number,
    regex,
    email, Create,
    choices, Button, SelectInput, ReferenceInput, AutocompleteInput,
    Edit, SimpleForm, TextInput,
    DateInput, BooleanInput, NumberInput, FileInput, FileField,
    ImageInput, ImageField, SaveButton, Toolbar, DeleteButton
} from 'react-admin';
import moment from 'moment';
import RichTextInput from 'ra-input-rich-text';
import { useForm } from 'react-final-form';
import CancelIcon from '@material-ui/icons/Cancel';
import SaveIcon from '@material-ui/icons/Save';
import * as apiClient from "../../../common/apiClient";
import PopupCreateToolbar from "../../../common/PopupCreateToolbar";
import { makeStyles } from '@material-ui/core/styles';
import { useStyles } from "../../../formStyles";

const TriggerDocumentsCreate = props => {
    const classes = useStyles({});
    const initialValues = {
        calimOrdId: props.calimOrdId
    }
    const handleSubmit = (formdata) => {
        //console.log(formdata);
        let m = moment(new Date());
        let data = {
            calimOrdId: parseInt(formdata.calimOrdId),
            slno: formdata.slno,
            trigDocs: formdata.trigDocs,
            additionalDocument: formdata.additionalDocument,
            isVerified: false,
            invVerifyRemarks:"",
            docurl: "",
            createdBy: 1,
            createdDate : m.toISOString()
        }
        apiClient.addEntiyRecord("claim-ord-invs", data).then(res => {
            //console.log(res);
            props.onClose();
        }).catch(err => {
            console.log(err);
        });
    }
    return (
        <Create { ...props }>
            <SimpleForm
                onSubmit={ handleSubmit }
                initialValues={ initialValues }
                toolbar={ <PopupCreateToolbar label="Save" onSave={ handleSubmit } onClose={ props.onClose } onCancel={ props.onCancel } /> }
                variant="outlined">
                <TextInput source="slno" label="SL No" fullWidth={ true } />
                <TextInput source="trigDocs" label="Trigger Detail" fullWidth={ true } />
                <TextInput label="Additional Detail" source="additionalDocument" fullWidth={ true }/>
            </SimpleForm>
        </Create>
    );
}
export default TriggerDocumentsCreate;